const USERS_KEY = 'my_blog_users_v1';
const CURRENT_KEY = 'my_blog_current_user';

function _getUsers() {
  try {
    return JSON.parse(localStorage.getItem(USERS_KEY)) || [];
  } catch (e) {
    return [];
  }
}

function _saveUsers(users) {
  localStorage.setItem(USERS_KEY, JSON.stringify(users));
}

export function register({ username, password }) {
  const users = _getUsers();
  if (users.find(u => u.username === username)) {
    return { ok: false, error: '用户名已存在' };
  }
  const user = { username, password, profile: { displayName: username, bio: '', website: '', avatarUrl: '' } };
  users.push(user);
  _saveUsers(users);
  // store current user with profile for convenience
  localStorage.setItem(CURRENT_KEY, JSON.stringify({ username, profile: user.profile }));
  try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  return { ok: true, user: { username, profile: user.profile } };
}

export function login({ username, password }) {
  const users = _getUsers();
  const u = users.find(x => x.username === username && x.password === password);
  if (!u) return { ok: false, error: '用户名或密码错误' };
  localStorage.setItem(CURRENT_KEY, JSON.stringify({ username, profile: u.profile || { displayName: username, bio: '', website: '', avatarUrl: '' } }));
  try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  return { ok: true, user: { username, profile: u.profile } };
}

export function logout() {
  localStorage.removeItem(CURRENT_KEY);
}

export function getCurrentUser() {
  try {
    const cur = JSON.parse(localStorage.getItem(CURRENT_KEY));
    if (!cur) return null;
    // if profile included, return directly
    if (cur.profile) return cur;
    // otherwise, try to merge profile from users
    const users = _getUsers();
    const u = users.find(x => x.username === cur.username);
    return { username: cur.username, profile: u?.profile || null };
  } catch (e) {
    return null;
  }
}

export function isAuthenticated() {
  return !!getCurrentUser();
}

export function getProfile(username) {
  const users = _getUsers();
  return users.find(u => u.username === username)?.profile || null;
}

export function updateProfile(username, profile) {
  const users = _getUsers();
  const idx = users.findIndex(u => u.username === username);
  if (idx === -1) return { ok: false, error: '用户不存在' };
  users[idx].profile = { ...(users[idx].profile || {}), ...profile };
  _saveUsers(users);
  // update current user storage so other tabs/components can pick up change
  const cur = getCurrentUser();
  if (cur && cur.username === username) {
    localStorage.setItem(CURRENT_KEY, JSON.stringify({ username, profile: users[idx].profile }));
    // dispatch storage event so same-window listeners update
    try { window.dispatchEvent(new Event('storage')); } catch (e) {}
  }
  return { ok: true, profile: users[idx].profile };
}

export function updatePassword(username, oldPassword, newPassword) {
  const users = _getUsers();
  const idx = users.findIndex(u => u.username === username);
  if (idx === -1) return { ok: false, error: '用户不存在' };
  if (users[idx].password !== oldPassword) return { ok: false, error: '旧密码不正确' };
  users[idx].password = newPassword;
  _saveUsers(users);
  return { ok: true };
}
